// extracted by mini-css-extract-plugin
export default {"card":"Card_card__qUaTP","card_title":"Card_card_title__Vfiw6","icon":"Card_icon__PmglF","ques":"Card_ques__H2Z3c","card_desc":"Card_card_desc__Ra7H2"};